import React from 'react'
import { Card, CardContent, Grid } from '@material-ui/core'
import { components, DataFlattener, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import NaCountryCodeKeys from 'src/constants/locale/key/NaCountryCode'
import makeValidationSchema from './MakeValidationSchema'

const {
  card: { CngSimpleCardHeader },
  form: {
    field: {
      CngTextField,
      CngSwitchField,
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  code:          '',
  descriptionEn: '',
  indicator:     '',
  intlcode:      '',
  active:        true,
  codeMType:     'NACountryCode',
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema,
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const { translate } = useTranslation(Namespace.NA_COUNTRY_CODE)

  function t(key) {
    return translate(Namespace.NA_COUNTRY_CODE, key)
  }

  return (
    <Card>
      <CngSimpleCardHeader title={t(NaCountryCodeKeys.TITLE)} />
      <CardContent>
        <Grid container spacing={3}>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.code}>
            <CngTextField
              name='code'
              label={t(NaCountryCodeKeys.CODE) + ' *'}
              disabled={disabled}
              inputProps={{ maxLength: 10 }}
            />
          </CngGridItem>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.descriptionEn}>
            <CngTextField
              name='descriptionEn'
              label={t(NaCountryCodeKeys.DESCRIPTION_EN) + ' *'}
              disabled={disabled}
              inputProps={{ maxLength: 100 }}
            />
          </CngGridItem>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.indicator}>
            <CngTextField
              name='indicator'
              label={t(NaCountryCodeKeys.INDICATOR) + ' *'}
              disabled={disabled}
              inputProps={{ maxLength: 10 }}
            />
          </CngGridItem>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.intlcode}>
            <CngTextField
              name='intlcode'
              label={t(NaCountryCodeKeys.INTLCODE)}
              disabled={disabled}
              inputProps={{ maxLength: 5 }}
            />
          </CngGridItem>

          <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.active}>
            <CngSwitchField
              name='active'
              label={t(NaCountryCodeKeys.ACTIVE)}
            />
          </CngGridItem>

        </Grid>
      </CardContent>
    </Card>
  )
}

function toClientDataFormat(serverData) {
  return DataFlattener.parse(serverData)
}

function toServerDataFormat(localData) {
  localData.codeMType = 'NACountryCode'
  return DataFlattener.unflatten(localData)
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields,
  toClientDataFormat,
  toServerDataFormat,
})

export default FormProperties
